import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`alert alert-${this.type}`),
    role: "alert",
    style: _normalizeStyle(_ctx.small ? '--bs-alert-padding-y: 0.5rem;' : '')
  }, [
    (_ctx.message && _ctx.small)
      ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(_ctx.message), 1))
      : (_ctx.message && !_ctx.small)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.message), 1)
          ], 64))
        : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ], 6))
}